import styles from "./InfoPage.module.scss"; // Імпортуємо SCSS файл для стилів
import Nav from "@/components/Header/Nav/Nav";
import Footer from "@/components/Footer/Footer";
// import CookiePopupButton from "@/components/CookieBanner/CookiePopupButton.tsx";
import { useEffect } from "react";
import CookiePopupButton from "../../components/CookieBanner/CookiePopupButton";
import { Helmet } from "react-helmet";

const Datenschutzerklarung = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Скролимо в верх сторінки
  }, []);
  return (
    <div>
      <Helmet>
        <title>
          Datenschutzerklärung &mdash; DSG Reparatur &amp; Wartung – HIXA Berlin
        </title>
        <link rel="icon" href="/images/favicon.ico" type="image/x-icon" />
        <link
          crossOrigin="anonymous"
          data-rocket-preconnect
          href="https://app.eu.usercentrics.eu"
          rel="preconnect"
        />
        <link
          crossOrigin="anonymous"
          data-rocket-preload
          as="font"
          href="https://hixa.eu/wp-content/uploads/InterTight-Regular.woff2"
          rel="preload"
        />
        <link
          rel="preload"
          data-rocket-preload
          as="image"
          href="/images/SEO/site-logo.svg"
          fetchPriority="high"
        />
        <meta
          name="description"
          content="Datenschutzerklärung – Professionelle Diagnose, Reparatur und Wartung von DSG-Getrieben. Jetzt Beratung anfragen!"
        />
        <meta
          name="robots"
          content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
        />
        <link rel="canonical" href="https://hixa.eu/datenschutzerklarung/" />
        <meta property="og:locale" content="de_DE" />
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Datenschutzerklärung &mdash; DSG Reparatur &amp; Wartung – HIXA Berlin"
        />
        <meta
          property="og:description"
          content="Datenschutzerklärung – Professionelle Diagnose, Reparatur und Wartung von DSG-Getrieben. Jetzt Beratung anfragen!"
        />
        <meta
          property="og:url"
          content="https://hixa.eu/datenschutzerklarung/"
        />
        <meta
          property="og:site_name"
          content="HIXA – DSG Getriebe Reparatur &amp; Wartung"
        />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/hixa.eu"
        />
        <meta property="og:image" content="/images/SEO/Hixa-Logo-1200.jpg" />
        <meta
          property="og:image:secure_url"
          content="/images/SEO/Hixa-Logo-1200.jpg"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="Hixa Logo 1200" />
        <meta property="og:image:type" content="image/jpeg" />
        <meta
          property="article:published_time"
          content="2025-04-26T08:25:36+00:00"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Datenschutzerklärung &mdash; DSG Reparatur &amp; Wartung – HIXA Berlin"
        />
        <meta
          name="twitter:description"
          content="Datenschutzerklärung – Professionelle Diagnose, Reparatur und Wartung von DSG-Getrieben. Jetzt Beratung anfragen!"
        />
        <meta name="twitter:image" content="/images/SEO/Hixa-Logo-1200.jpg" />
        <meta name="twitter:label1" content="Zeit zum Lesen" />
        <meta name="twitter:data1" content="15 Minuten" />

        <script type="application/ld+json" className="rank-math-schema">
          {`{
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Place",
          "@id": "https://hixa.eu/#place",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Neukirchstraße 74",
            "addressLocality": "Berlin",
            "addressRegion": "Berlin",
            "postalCode": "13089"
          }
        },
        {
          "@type": "Organization",
          "@id": "https://hixa.eu/#organization",
          "name": "HIXA – DSG Getriebe Reparatur & Wartung",
          "url": "https://hixa.eu",
          "sameAs": ["https://www.facebook.com/hixa.eu"],
          "email": "kunden@hixa.eu",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Neukirchstraße 74",
            "addressLocality": "Berlin",
            "addressRegion": "Berlin",
            "postalCode": "13089"
          },
          "logo": {
            "@type": "ImageObject",
            "@id": "https://hixa.eu/#logo",
            "url": "/images/SEO/Hixa-logo-250.jpg", 
            "contentUrl": "/images/SEO/Hixa-logo-250.jpg", 
            "caption": "HIXA – DSG Getriebe Reparatur & Wartung",
            "inLanguage": "de",
            "width": 300,
            "height": 300
          },
          "contactPoint": [
            {
              "@type": "ContactPoint",
              "telephone": "+49 30 520 151 91",
              "contactType": "customer support"
            }
          ],
          "description": "HIXA ist Ihr Spezialist für DSG-, Multitronic- und Automatikgetriebe-Reparaturen in Berlin und deutschlandweit. Wir bieten professionelle Diagnose, Reparatur, Wartung und Austausch mit 12 Monaten Garantie.",
          "location": {
            "@id": "https://hixa.eu/#place"
          }
        },
        {
          "@type": "WebSite",
          "@id": "https://hixa.eu/#website",
          "url": "https://hixa.eu",
          "name": "HIXA – DSG Getriebe Reparatur & Wartung",
          "publisher": {
            "@id": "https://hixa.eu/#organization"
          },
          "inLanguage": "de"
        },
        {
          "@type": "ImageObject",
          "@id": "/images/SEO/Hixa-Logo-1200.jpg",
          "url": "/images/SEO/Hixa-Logo-1200.jpg",
          "width": 1200,
          "height": 630,
          "caption": "Hixa Logo 1200",
          "inLanguage": "de"
        },
        {
          "@type": "WebPage",
          "@id": "https://hixa.eu/datenschutzerklarung/#webpage",
          "url": "https://hixa.eu/datenschutzerklarung/",
          "name": "Datenschutzerklärung &mdash; DSG Reparatur & Wartung – HIXA Berlin",
          "datePublished": "2025-04-26T08:25:36+00:00",
          "dateModified": "2025-04-26T08:25:36+00:00",
          "isPartOf": {
            "@id": "https://hixa.eu/#website"
          },
          "primaryImageOfPage": {
            "@id": "/images/SEO/Hixa-Logo-1200.jpg"
          },
          "inLanguage": "de"
        },
        {
          "@type": "Article",
          "headline": "Datenschutzerklärung &mdash; DSG Reparatur & Wartung – HIXA Berlin",
          "datePublished": "2025-04-26T08:25:36+00:00",
          "dateModified": "2025-04-26T08:25:36+00:00",
          "author": {
            "@id": "https://hixa.eu/datenschutzerklarung/#author",
            "name": "wondermega victor"
          },
          "publisher": {
            "@id": "https://hixa.eu/#organization"
          },
          "description": "Datenschutzerklärung – Professionelle Diagnose, Reparatur und Wartung von DSG-Getrieben. Jetzt Beratung anfragen!",
          "name": "Datenschutzerklärung &mdash; DSG Reparatur & Wartung – HIXA Berlin",
          "@id": "https://hixa.eu/datenschutzerklarung/#richSnippet",
          "isPartOf": {
            "@id": "https://hixa.eu/datenschutzerklarung/#webpage"
          },
          "image": {
            "@id": "/images/SEO/Hixa-Logo-1200.jpg"
          },
          "inLanguage": "de",
          "mainEntityOfPage": {
            "@id": "https://hixa.eu/datenschutzerklarung/#webpage"
          }
        }
      ]
    }`}
        </script>

        <link
          rel="alternate"
          type="application/rss+xml"
          title="HIXA – DSG Getriebe Reparatur &amp; Wartung &raquo; Feed"
          href="https://hixa.eu/feed/"
        />
        <link
          rel="alternate"
          type="application/rss+xml"
          title="HIXA – DSG Getriebe Reparatur &amp; Wartung &raquo; Kommentar-Feed"
          href="https://hixa.eu/comments/feed/"
        />
      </Helmet>

      <Nav />
      <h2 className={` sectionContainer ${styles.title}`}>
        Datenschutzerklärung
      </h2>
      <div className="container sectionContainer sectionContainerWhite">
        <p className={styles.infoPageText}>
          Soweit nachstehend keine anderen Angaben gemacht werden, ist die
          Bereitstellung Ihrer personenbezogenen Daten weder gesetzlich oder
          vertraglich vorgeschrieben, noch für einen Vertragsabschluss
          erforderlich. Sie sind zur Bereitstellung der Daten nicht
          verpflichtet. Eine Nichtbereitstellung hat keine Folgen. Dies gilt nur
          soweit bei den nachfolgenden Verarbeitungsvorgängen keine anderweitige
          Angabe gemacht wird.
        </p>

        <p className={styles.infoPageText}>
          “Personenbezogene Daten” sind alle Informationen, die sich auf eine
          identifizierte oder identifizierbare natürliche Person beziehen.
        </p>

        <p className={styles.infoPageText}>Server-Logfiles</p>
        <p className={styles.infoPageText}>
          Sie können unsere Webseiten besuchen, ohne Angaben zu Ihrer Person zu
          machen.
        </p>
        <p className={styles.infoPageText}>
          Bei jedem Zugriff auf unsere Website werden an uns oder unseren
          Webhoster / IT-Dienstleister Nutzungsdaten durch Ihren Internet
          Browser übermittelt und in Protokolldaten (sog. Server-Logfiles)
          gespeichert. Zu diesen gespeicherten Daten gehören z.B. der Name der
          aufgerufenen Seite, Datum und Uhrzeit des Abrufs, die IP-Adresse, die
          übertragene Datenmenge und der anfragende Provider. Die Verarbeitung
          erfolgt auf Grundlage des Art. 6 Abs. 1 lit. f DSGVO aus unserem
          überwiegenden berechtigten Interesse an der Gewährleistung eines
          störungsfreien Betriebs unserer Website sowie zur Verbesserung unseres
          Angebotes.
        </p>

        <h2 className={styles.infoPageHeader}>Kontakt</h2>
        <p className={styles.infoPageText}>Verantwortlicher</p>
        <p className={styles.infoPageText}>
          Kontaktieren Sie uns auf Wunsch. Die Kontaktdaten des für die
          Datenverarbeitung Verantwortlichen finden Sie in unserem Impressum.
        </p>

        <p className={styles.infoPageText}>
          Initiativ-Kontaktaufnahme des Kunden per E-Mail
        </p>
        <p className={styles.infoPageText}>
          Wenn Sie per E-Mail initiativ mit uns in Geschäftskontakt treten,
          erheben wir Ihre personenbezogenen Daten (Name, E-Mail-Adresse,
          Nachrichtentext) nur in dem von Ihnen zur Verfügung gestellten Umfang.
          Die Datenverarbeitung dient der Bearbeitung und Beantwortung Ihrer
          Kontaktanfrage.
        </p>
        <p className={styles.infoPageText}>
          Wenn die Kontaktaufnahme der Durchführung vorvertraglichen Maßnahmen
          (bspw. Beratung bei Kaufinteresse, Angebotserstellung) dient oder
          einen bereits zwischen Ihnen und uns geschlossenen Vertrag betrifft,
          erfolgt diese Datenverarbeitung auf Grundlage des Art. 6 Abs. 1 lit. b
          DSGVO.
        </p>
        <p className={styles.infoPageText}>
          Erfolgt die Kontaktaufnahme aus anderen Gründen erfolgt diese
          Datenverarbeitung auf Grundlage des Art. 6 Abs. 1 lit. f DSGVO aus
          unserem überwiegenden berechtigten Interesse an der Bearbeitung und
          Beantwortung Ihrer Anfrage. In diesem Fall haben Sie das Recht, aus
          Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit
          dieser auf Art. 6 Abs. 1 lit. f DSGVO beruhenden Verarbeitungen Sie
          betreffender personenbezogener Daten zu widersprechen.
        </p>

        <h2 className={styles.infoPageHeader}>Daten zu Widersprechen.</h2>
        <p className={styles.infoPageText}>
          Ihre E-Mail-Adresse nutzen wir nur zur Bearbeitung Ihrer Anfrage. Ihre
          Daten werden anschließend unter Beachtung gesetzlicher
          Aufbewahrungsfristen gelöscht, sofern Sie der weitergehenden
          Verarbeitung und Nutzung nicht zugestimmt haben.
        </p>

        <h2 className={styles.infoPageHeader}>
          Erhebung und Verarbeitung bei Nutzung des Kontaktformulars
        </h2>
        <p className={styles.infoPageText}>
          Bei der Nutzung des Kontaktformulars erheben wir Ihre
          personenbezogenen Daten (Name, E-Mail-Adresse, Nachrichtentext) nur in
          dem von Ihnen zur Verfügung gestellten Umfang. Die Datenverarbeitung
          dient dem Zweck der Kontaktaufnahme.
        </p>
        <p className={styles.infoPageText}>
          Wenn die Kontaktaufnahme der Durchführung vorvertraglichen Maßnahmen
          (bspw. Beratung bei Kaufinteresse, Angebotserstellung) dient oder
          einen bereits zwischen Ihnen und uns geschlossenen Vertrag betrifft,
          erfolgt diese Datenverarbeitung auf Grundlage des Art. 6 Abs. 1 lit. b
          DSGVO. Erfolgt die Kontaktaufnahme aus anderen Gründen erfolgt diese
          Datenverarbeitung auf Grundlage des Art. 6 Abs. 1 lit. f DSGVO aus
          unserem überwiegenden berechtigten Interesse an der Bearbeitung und
          Beantwortung Ihrer Anfrage. In diesem Fall haben Sie das Recht, aus
          Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit
          dieser auf Art. 6 Abs. 1 lit. f DSGVO beruhenden Verarbeitungen Sie
          betreffender personenbezogener Daten zu widersprechen.
        </p>
        <p className={styles.infoPageText}>
          Ihre E-Mail-Adresse nutzen wir nur zur Bearbeitung Ihrer Anfrage. Ihre
          Daten werden anschließend unter Beachtung gesetzlicher
          Aufbewahrungsfristen gelöscht, sofern Sie der weitergehenden
          Verarbeitung und Nutzung nicht zugestimmt haben.
        </p>

        <h2 className={styles.infoPageHeader}>WhatsApp Business</h2>
        <p className={styles.infoPageText}>
          Wenn Sie per WhatsApp mit uns in Geschäftskontakt treten, nutzen wir
          hierfür die Version WhatsApp Business der WhatsApp Ireland Limited (4
          Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland;
          “WhatsApp”). Soweit Sie Ihren Aufenthalt außerhalb des Europäischen
          Wirtschaftsraumes haben, wird dieser Dienst durch die WhatsApp Inc.
          (1601 Willow Road, Menlo Park, CA 94025, USA) bereitgestellt.
        </p>
        <p className={styles.infoPageText}>
          Die Datenverarbeitung dient der Bearbeitung und Beantwortung Ihrer
          Kontaktanfrage. Zu diesem Zweck erheben und verarbeiten wir Ihre bei
          WhatsApp hinterlegte Mobilfunknummer, falls bereitgestellt Ihren Namen
          sowie weitere Daten in dem von Ihnen zur Verfügung gestellten Umfang.
          Wir verwenden für den Dienst ein mobiles Endgerät, in dessen
          Adressbuch ausschließlich Daten von Nutzern gespeichert sind, die uns
          über WhatsApp kontaktiert haben. Eine Weitergabe personenbezogener
          Daten an WhatsApp, ohne dass Sie hierin bereits gegenüber WhatsApp
          eingewilligt haben, erfolgt damit nicht.
        </p>
        <p className={styles.infoPageText}>
          Ihre Daten werden von WhatsApp an Server der Facebook Inc. in den USA
          übermittelt.
        </p>
        <p className={styles.infoPageText}>
          Wenn die Kontaktaufnahme der Durchführung vorvertraglichen Maßnahmen
          (bspw. Beratung bei Kaufinteresse, Angebotserstellung) dient oder
          einen bereits zwischen Ihnen und uns geschlossenen Vertrag betrifft,
          erfolgt diese Datenverarbeitung auf Grundlage des Art. 6 Abs. 1 lit. b
          DSGVO.
        </p>
        <p className={styles.infoPageText}>
          Erfolgt die Kontaktaufnahme aus anderen Gründen erfolgt diese
          Datenverarbeitung auf Grundlage des Art. 6 Abs. 1 lit. f DSGVO aus
          unserem überwiegenden berechtigten Interesse am Bereitstellen einer
          schnellen und einfachen Kontaktaufnahme sowie an der Beantwortung
          Ihrer Anfrage. In diesem Fall haben Sie das Recht, aus Gründen, die
          sich aus Ihrer besonderen Situation ergeben, jederzeit dieser auf Art.
          6 Abs. 1 lit. f DSGVO beruhenden Verarbeitungen Sie betreffender
          personenbezogener Daten zu widersprechen.
        </p>
        <p className={styles.infoPageText}>
          Ihre personenbezogenen Daten nutzen wir nur zur Bearbeitung Ihrer
          Anfrage. Ihre Daten werden anschließend unter Beachtung gesetzlicher
          Aufbewahrungsfristen gelöscht, sofern Sie der weitergehenden
          Verarbeitung und Nutzung nicht zugestimmt haben.
        </p>

        <h2 className={styles.infoPageHeader}>Kundenkonto Bestellungen</h2>
        <p className={styles.infoPageDate}>Kundenkonto</p>
        <p className={styles.infoPageText}>
          Bei der Eröffnung eines Kundenkontos erheben wir Ihre
          personenbezogenen Daten in dem dort angegebenen Umfang. Die
          Datenverarbeitung dient dem Zweck, Ihr Einkaufserlebnis zu verbessern
          und die Bestellabwicklung zu vereinfachen. Die Verarbeitung erfolgt
          auf Grundlage des Art. 6 Abs. 1 lit. a DSGVO mit Ihrer Einwilligung.
          Sie können Ihre Einwilligung jederzeit durch Mitteilung an uns
          widerrufen, ohne dass die Rechtmäßigkeit der aufgrund der Einwilligung
          bis zum Widerruf erfolgten Verarbeitung berührt wird. Ihr Kundenkonto
          wird anschließend gelöscht.
        </p>

        <h2 className={styles.infoPageHeader}>
          Erhebung, Verarbeitung und Weitergabe personenbezogener Daten bei
          Bestellungen
        </h2>
        <p className={styles.infoPageText}>
          Bei der Bestellung erheben und verarbeiten wir Ihre personenbezogenen
          Daten nur, soweit dies zur Erfüllung und Abwicklung Ihrer Bestellung
          sowie zur Bearbeitung Ihrer Anfragen erforderlich ist. Die
          Bereitstellung der Daten ist für den Vertragsschluss erforderlich.
          Eine Nichtbereitstellung hat zur Folge, dass kein Vertrag geschlossen
          werden kann. Die Verarbeitung erfolgt auf Grundlage des Art. 6 Abs. 1
          lit. b DSGVO und ist für die Erfüllung eines Vertrags mit Ihnen
          erforderlich.
        </p>
        <p className={styles.infoPageText}>
          Eine Weitergabe Ihrer Daten erfolgt dabei beispielsweise an die von
          Ihnen gewählten Versandunternehmen und Dropshipping Anbieter,
          Zahlungsdienstleister, Diensteanbieter für die Bestellabwicklung und
          IT-Dienstleister. In allen Fällen beachten wir strikt die gesetzlichen
          Vorgaben. Der Umfang der Datenübermittlung beschränkt sich auf ein
          Mindestmaß.
        </p>

        <h2 className={styles.infoPageHeader}>Bewertungen Werbung</h2>
        <p className={styles.infoPageDate}>
          Datenerhebung bei Verfassung eines Kommentars
        </p>
        <p className={styles.infoPageText}>
          Bei der Kommentierung eines Artikels oder eines Beitrages erheben wir
          Ihre personenbezogenen Daten (Name, E-Mail-Adresse, Kommentartext) nur
          in dem von Ihnen zur Verfügung gestellten Umfang. Die Verarbeitung
          dient dem Zweck, eine Kommentierung zu ermöglichen und Kommentare
          anzuzeigen. Mit Absenden des Kommentars willigen Sie in die
          Verarbeitung der übermittelten Daten ein. Die Verarbeitung erfolgt auf
          Grundlage des Art. 6 Abs. 1 lit. a DSGVO mit Ihrer Einwilligung. Sie
          können die Einwilligung jederzeit durch Mitteilung an uns widerrufen,
          ohne dass die Rechtmäßigkeit der aufgrund der Einwilligung bis zum
          Widerruf erfolgten Verarbeitung berührt wird. Ihre personenbezogenen
          Daten werden anschließend gelöscht.
        </p>

        <h2 className={styles.infoPageHeader}>
          Verwendung der E-Mail-Adresse für die Zusendung von Newslettern
        </h2>
        <p className={styles.infoPageDate}>
          Wir nutzen Ihre E-Mail-Adresse unabhängig von der Vertragsabwicklung
          ausschließlich für eigene Werbezwecke zum Newsletterversand, sofern
          Sie dem ausdrücklich zugestimmt haben. Die Verarbeitung erfolgt auf
          Grundlage des Art. 6 Abs. 1 lit. a DSGVO mit Ihrer Einwilligung. Sie
          können die Einwilligung jederzeit widerrufen, ohne dass die
          Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf
          erfolgten Verarbeitung berührt wird. Sie können dazu den Newsletter
          jederzeit unter Nutzung des entsprechenden Links im Newsletter oder
          durch Mitteilung an uns abbestellen. Ihre E-Mail-Adresse wird danach
          aus dem Verteiler entfernt.
        </p>

        <h2 className={styles.infoPageHeader}>
          Verwendung der E-Mail-Adresse für die Zusendung von Direktwerbung
        </h2>
        <p className={styles.infoPageDate}>
          Wir nutzen Ihre E-Mail-Adresse, die wir im Rahmen des Verkaufes einer
          Ware oder Dienstleistung erhalten haben, für die elektronische
          Übersendung von Werbung für eigene Waren oder Dienstleistungen, die
          denen ähnlich sind, die Sie bereits bei uns erworben haben, soweit Sie
          dieser Verwendung nicht widersprochen haben. Die Bereitstellung der
          E-Mail-Adresse ist für den Vertragsschluss erforderlich. Eine
          Nichtbereitstellung hat zur Folge, dass kein Vertrag geschlossen
          werden kann. Die Verarbeitung erfolgt auf Grundlage des Art. 6 Abs. 1
          lit. f DSGVO aus unserem überwiegenden berechtigten Interesse an
          Direktwerbung. Sie können dieser Verwendung Ihrer E-Mail-Adresse
          jederzeit durch Mitteilung an uns widersprechen. Die Kontaktdaten für
          die Ausübung des Widerspruchs finden Sie im Impressum. Sie können auch
          den dafür vorgesehenen Link in der Werbe-E-Mail nutzen. Hierfür
          entstehen keine anderen als die Übermittlungskosten nach den
          Basistarifen.
        </p>

        <h2 className={styles.infoPageHeader}>Versanddienstleister</h2>
        <p className={styles.infoPageDate}>
          Weitergabe der E-Mail-Adresse an Versandunternehmen zur Information
          über den Versandstatus
        </p>
        <p className={styles.infoPageText}>
          Wir geben Ihre E-Mail-Adresse im Rahmen der Vertragsabwicklung an das
          Transportunternehmen weiter, sofern Sie dem ausdrücklich im
          Bestellvorgang zugestimmt haben. Die Weitergabe dient dem Zweck, Sie
          per E-Mail über den Versandstatus zu informieren. Die Verarbeitung
          erfolgt auf Grundlage des Art. 6 Abs. 1 lit. a DSGVO mit Ihrer
          Einwilligung. Sie können die Einwilligung jederzeit durch Mitteilung
          an uns oder das Transportunternehmen widerrufen, ohne dass die
          Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf
          erfolgten Verarbeitung berührt wird.
        </p>

        <h2 className={styles.infoPageHeader}>Zahlungsdienstleister</h2>
        <p className={styles.infoPageDate}>Verwendung von PayPal</p>
        <p className={styles.infoPageText}>
          Alle PayPal-Transaktionen unterliegen der PayPal-Datenschutzerklärung.
          Diese finden Sie unter{" "}
          <a
            href="https://www.paypal.com/de/webapps/mpp/ua/privacy-full"
            target="_blank"
          >
            https://www.paypal.com/de/webapps/mpp/ua/privacy-full
          </a>
        </p>

        <p className={styles.infoPageDate}>Verwendung von PayPal Express</p>
        <p className={styles.infoPageText}>
          Wir verwenden auf unserer Website den Zahlungsdienst PayPal Express
          der PayPal (Europe) S.à.r.l. et Cie, S.C.A. (22-24 Boulevard Royal
          L-2449, Luxemburg; “PayPal”). Die Datenverarbeitung dient dem Zweck,
          Ihnen die Zahlung über den Zahlungsdienst PayPal Express anbieten zu
          können. Zur Einbindung dieses Zahlungsdienstes ist es erforderlich,
          dass PayPal beim Aufruf der Website Daten (z.B. IP-Adresse, Gerätetyp,
          Betriebssystem, Browsertyp, Standort Ihres Geräts) sammelt, speichert
          und analysiert. Hierzu können auch Cookies eingesetzt werden. Die
          Cookies ermöglichen die Wiedererkennung Ihres Browsers.
        </p>

        <p className={styles.infoPageText}>
          Die Nutzung von Cookies oder vergleichbarer Technologien erfolgt auf
          Grundlage des § 15 Abs. 3 S. 1 TMG. Die Verarbeitung Ihrer
          personenbezogenen Daten erfolgt auf Grundlage des Art. 6 Abs. 1 lit. f
          DSGVO aus unserem überwiegenden berechtigten Interesse an einem
          kundenorientierten Angebot von verschiedenen Zahlarten. Sie haben das
          Recht aus Gründen, die sich aus Ihrer besonderen Situation ergeben,
          jederzeit dieser Verarbeitungen Sie betreffender personenbezogener
          Daten zu widersprechen.
        </p>

        <h2 className={styles.infoPageHeader}>Cookies</h2>
        <p className={styles.infoPageText}>
          Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die
          im Internetbrowser bzw. vom Internetbrowser auf dem Computersystem
          eines Nutzers gespeichert werden. Ruft ein Nutzer eine Website auf, so
          kann ein Cookie auf dem Betriebssystem des Nutzers gespeichert werden.
          Dieses Cookie enthält eine charakteristische Zeichenfolge, die eine
          eindeutige Identifizierung des Browsers beim erneuten Aufrufen der
          Website ermöglicht.
        </p>

        <p className={styles.infoPageText}>
          Cookies werden auf Ihrem Rechner gespeichert. Daher haben Sie die
          volle Kontrolle über die Verwendung von Cookies. Durch die Auswahl
          entsprechender technischer Einstellungen in Ihrem Internetbrowser
          können Sie vor dem Setzen von Cookies benachrichtigt werden und über
          die Annahme einzeln entscheiden sowie die Speicherung der Cookies und
          Übermittlung der enthaltenen Daten verhindern. Bereits gespeicherte
          Cookies können jederzeit gelöscht werden. Wir weisen Sie jedoch darauf
          hin, dass Sie dann gegebenenfalls nicht sämtliche Funktionen dieser
          Website vollumfänglich werden nutzen können.
        </p>

        <p className={styles.infoPageText}>
          Unter den nachstehenden Links können Sie sich informieren, wie Sie die
          Cookies bei den wichtigsten Browsern verwalten (u.a. auch
          deaktivieren) können:
        </p>
        <p className={styles.infoPageText}>
          Chrome:{" "}
          <a
            href="https://support.google.com/accounts/answer/61416?hl=de"
            target="_blank"
          >
            https://support.google.com/accounts/answer/61416?hl=de
          </a>
        </p>

        <p className={styles.infoPageText}>
          Internet Explorer:{" "}
          <a
            href="https://support.microsoft.com/de-de/help/17442/windows-internet-explorer-delete-manage-cookies"
            target="_blank"
          >
            https://support.microsoft.com/de-de/help/17442/windows-internet-explorer-delete-manage-cookies
          </a>
        </p>

        <p className={styles.infoPageText}>
          Mozilla Firefox:{" "}
          <a
            href="https://support.mozilla.org/de/kb/cookies-erlauben-und-ablehnen"
            target="_blank"
          >
            https://support.mozilla.org/de/kb/cookies-erlauben-und-ablehnen
          </a>
        </p>

        <p className={styles.infoPageText}>
          Safari:{" "}
          <a
            href="https://support.apple.com/de-de/guide/safari/manage-cookies-and-website-data-sfri11471/mac"
            target="_blank"
          >
            https://support.apple.com/de-de/guide/safari/manage-cookies-and-website-data-sfri11471/mac
          </a>
        </p>

        <h2 className={styles.infoPageHeader}>Technisch notwendige Cookies</h2>
        <p className={styles.infoPageText}>
          Soweit nachstehend in der Datenschutzerklärung keine anderen Angaben
          gemacht werden setzen wir nur diese technisch notwendigen Cookies zu
          dem Zweck ein, unser Angebot nutzerfreundlicher, effektiver und
          sicherer zu machen. Des Weiteren ermöglichen Cookies unseren Systemen,
          Ihren Browser auch nach einem Seitenwechsel zu erkennen und Ihnen
          Services anzubieten. Einige Funktionen unserer Internetseite können
          ohne den Einsatz von Cookies nicht angeboten werden. Für diese ist es
          erforderlich, dass der Browser auch nach einem Seitenwechsel
          wiedererkannt wird.
        </p>

        <p className={styles.infoPageText}>
          Die Nutzung von Cookies oder vergleichbarer Technologien erfolgt auf
          Grundlage des § 15 Abs. 3 S. 1 TMG. Die Verarbeitung Ihrer
          personenbezogenen Daten erfolgt auf Grundlage des Art. 6 Abs. 1 lit. f
          DSGVO aus unserem überwiegenden berechtigten Interesse an der
          Gewährleistung der optimalen Funktionalität der Website sowie einer
          nutzerfreundlichen und effektiven Gestaltung unseres Angebots.
        </p>

        <p className={styles.infoPageText}>
          Sie haben das Recht aus Gründen, die sich aus Ihrer besonderen
          Situation ergeben, jederzeit dieser Verarbeitungen Sie betreffender
          personenbezogener Daten zu widersprechen.
        </p>

        <h2 className={styles.infoPageHeader}>Plug-ins und Sonstiges</h2>
        <p className={styles.infoPageDate}>Verwendung von Google reCAPTCHA</p>
        <p className={styles.infoPageText}>
          Wir verwenden auf unserer Website den Dienst reCAPTCHA der Google LLC
          (1600 Amphitheatre Parkway, Mountain View, CA 94043, USA; “Google”).
        </p>

        <p className={styles.infoPageText}>
          Soweit Sie Ihren gewöhnlichen Aufenthalt im Europäischen
          Wirtschaftsraum oder der Schweiz haben, ist Google Ireland Limited
          (Gordon House, Barrow Street, Dublin 4, Irland) der für Ihre Daten
          zuständige Verantwortliche. Google Ireland Limited ist demnach das mit
          Google verbundene Unternehmen, welches für die Verarbeitung Ihrer
          Daten und die Einhaltung der anwendbaren Datenschutzgesetze
          verantwortlich ist. Die Abfrage dient dem Zweck der Unterscheidung der
          Eingabe durch einen Menschen oder durch automatisierte, maschinelle
          Verarbeitung. Dazu wird Ihre Eingabe an Google übermittelt und dort
          weiterverwendet. Zusätzlich werden die IP-Adresse und gegebenenfalls
          weitere von Google für den Dienst reCAPTCHA benötigte Daten an Google
          übertragen. Diese Daten werden von Google innerhalb der Europäischen
          Union verarbeitet und gegebenenfalls auch in die USA übermittelt. Für
          die USA ist kein Angemessenheitsbeschluss der EU-Kommission vorhanden.
          Die Datenübermittlung erfolgt u.a auf Grundlage von
          Standardvertragsklauseln als geeignete Garantien für den Schutz der
          personenbezogenen Daten, einsehbar unter:{" "}
          <a
            href="https://policies.google.com/privacy/frameworks"
            target="_blank"
          >
            https://policies.google.com/privacy/frameworks
          </a>
        </p>

        <p className={styles.infoPageText}>
          Die Verarbeitung erfolgt auf Grundlage des Art. 6 Abs. 1 lit. f DSGVO
          aus dem berechtigten Interesse unsere Website vor automatisierter
          Ausspähung, Missbrauch und SPAM zu schützen. Sie haben das Recht aus
          Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit
          dieser auf Art. 6 Abs. 1 lit. f DSGVO beruhenden Verarbeitungen Sie
          betreffender personenbezogener Daten zu widersprechen.
        </p>

        <p className={styles.infoPageText}>
          Nähere Informationen zu Google reCAPTCHA sowie die dazugehörige
          Datenschutzerklärung finden Sie unter:{" "}
          <a
            href="https://www.google.com/recaptcha/intro/android.html"
            target="_blank"
          >
            https://www.google.com/recaptcha/intro/android.html
          </a>{" "}
          sowie{" "}
          <a href="https://www.google.com/privacy" target="_blank">
            https://www.google.com/privacy
          </a>
          .
        </p>

        <h2 className={styles.infoPageHeader}>Verwendung von Google Maps</h2>
        <p className={styles.infoPageText}>
          Wir verwenden auf unserer Website die Funktion zur Einbettung von
          Google Maps-Karten der Google LLC (1600 Amphitheatre Parkway, Mountain
          View, CA 94043, USA; “Google”).
        </p>

        <p className={styles.infoPageText}>
          Soweit Sie Ihren gewöhnlichen Aufenthalt im Europäischen
          Wirtschaftsraum oder der Schweiz haben, ist Google Ireland Limited
          (Gordon House, Barrow Street, Dublin 4, Irland) der für Ihre Daten
          zuständige Verantwortliche. Google Ireland Limited ist demnach das mit
          Google verbundene Unternehmen, welches für die Verarbeitung Ihrer
          Daten und die Einhaltung der anwendbaren Datenschutzgesetze
          verantwortlich ist.
        </p>

        <p className={styles.infoPageText}>
          Die Funktion ermöglicht die visuelle Darstellung von geographischen
          Informationen und interaktiven Landkarten. Dabei werden von Google bei
          Aufrufen der Seiten, in die Google Maps-Karten eingebunden sind, auch
          Daten der Besucher der Websites erhoben, verarbeitet und genutzt.
        </p>

        <p className={styles.infoPageText}>
          Ihre Daten werden dabei gegebenenfalls auch in die USA übermittelt.
          Für die USA ist kein Angemessenheitsbeschluss der EU-Kommission
          vorhanden. Die Datenübermittlung erfolgt u.a auf Grundlage von
          Standardvertragsklauseln als geeignete Garantien für den Schutz der
          personenbezogenen Daten, einsehbar unter:{" "}
          <a
            href="https://policies.google.com/privacy/frameworks"
            target="_blank"
          >
            https://policies.google.com/privacy/frameworks
          </a>
          .
        </p>

        <p className={styles.infoPageText}>
          Die Nutzung von Cookies oder vergleichbarer Technologien erfolgt auf
          Grundlage des § 15 Abs. 3 S. 1 TMG. Die Verarbeitung Ihrer
          personenbezogenen Daten erfolgt auf Grundlage des Art. 6 Abs. 1 lit. f
          DSGVO aus unserem überwiegenden berechtigten Interesse an der
          bedarfsgerechten und zielgerichteten Gestaltung der Website. Sie haben
          das Recht aus Gründen, die sich aus Ihrer besonderen Situation
          ergeben, jederzeit dieser Verarbeitungen Sie betreffender
          personenbezogener Daten zu widersprechen.
        </p>

        <p className={styles.infoPageText}>
          Nähere Informationen zur Erhebung und Nutzung der Daten durch Google
          finden Sie in den Datenschutzhinweisen von Google unter{" "}
          <a href="https://www.google.com/privacypolicy.html" target="_blank">
            https://www.google.com/privacypolicy.html
          </a>
          . Dort haben Sie auch im Datenschutzcenter die Möglichkeit, Ihre
          Einstellungen zu verändern, so dass Sie Ihre von Google verarbeiteten
          Daten verwalten und schützen können.
        </p>

        <h2 className={styles.infoPageHeader}>
          Betroffenenrechte und Speicherdauer
        </h2>
        <p className={styles.infoPageDate}>Dauer der Speicherung</p>
        <p className={styles.infoPageText}>
          Nach vollständiger Vertragsabwicklung werden die Daten zunächst für
          die Dauer der Gewährleistungsfrist, danach unter Berücksichtigung
          gesetzlicher, insbesondere steuer- und handelsrechtlicher
          Aufbewahrungsfristen gespeichert und dann nach Fristablauf gelöscht,
          sofern Sie der weitergehenden Verarbeitung und Nutzung nicht
          zugestimmt haben.
        </p>

        <p className={styles.infoPageText}>Rechte der betroffenen Person</p>
        <p className={styles.infoPageText}>
          Ihnen stehen bei Vorliegen der gesetzlichen Voraussetzungen folgende
          Rechte nach Art. 15 bis 20 DSGVO zu: Recht auf Auskunft, auf
          Berichtigung, auf Löschung, auf Einschränkung der Verarbeitung, auf
          Datenübertragbarkeit.
        </p>

        <p className={styles.infoPageText}>
          Außerdem steht Ihnen nach Art. 21 Abs. 1 DSGVO ein Widerspruchsrecht
          gegen die Verarbeitungen zu, die auf Art. 6 Abs. 1 f DSGVO beruhen,
          sowie gegen die Verarbeitung zum Zwecke von Direktwerbung.
        </p>

        <p className={styles.infoPageText}>
          Beschwerderecht bei der Aufsichtsbehörde
        </p>
        <p className={styles.infoPageText}>
          Sie haben gemäß Art. 77 DSGVO das Recht, sich bei der Aufsichtsbehörde
          zu beschweren, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer
          personenbezogenen Daten nicht rechtmäßig erfolgt.
        </p>

        <p className={styles.infoPageText}>Widerspruchsrecht</p>
        <p className={styles.infoPageText}>
          Beruhen die hier aufgeführten personenbezogenen Datenverarbeitungen
          auf Grundlage unseres berechtigten Interesses nach Art. 6 Abs. 1 lit.
          f DSGVO, haben Sie das Recht aus Gründen, die sich aus Ihrer
          besonderen Situation ergeben, jederzeit diesen Verarbeitungen mit
          Wirkung für die Zukunft zu widersprechen.
        </p>

        <p className={styles.infoPageText}>
          Nach erfolgtem Widerspruch wird die Verarbeitung der betroffenen Daten
          beendet, es sei denn, wir können zwingende schutzwürdige Gründe für
          die Verarbeitung nachweisen, die Ihren Interessen, Rechten und
          Freiheiten überwiegen, oder wenn die Verarbeitung der Geltendmachung,
          Ausübung oder Verteidigung von Rechtsansprüchen dient.
        </p>

        <p className={styles.infoPageText}>
          Erfolgt die personenbezogene Datenverarbeitung zu Zwecken der
          Direktwerbung, können Sie dieser Verarbeitung jederzeit durch
          Mitteilung an uns widersprechen. Nach erfolgtem Widerspruch beenden
          wir die Verarbeitung der betroffenen Daten zum Zwecke der
          Direktwerbung.
        </p>
      </div>
      <CookiePopupButton></CookiePopupButton>
      <Footer />
    </div>
  );
};

export default Datenschutzerklarung;
